var configurationModule = angular.module("tmx-configurations", []);
configurationModule.constant("ENV", ENV);
configurationModule.constant("APP_CONSTANTS", APP_CONSTANTS);

Date.prototype.toJSON = function(){ return moment(this).format('YYYY-MM-DDTHH:mm:ss'); }


//#region  Firebase Initialization and Overloads

    // Initialize Firebase
    firebase.initializeApp(firebaseConfig);
    firebase.analytics();

    // Custom Log event to control from configurations
    firebase.logTmxEvent = function(eventName, eventParams){
        if(Boolean(APP_CONSTANTS.enableFirebase) == true){
            firebase.analytics().logEvent(eventName,eventParams);
        }
    }
    //Custom Set user properties method to control from configurations
    firebase.setTmxUserProperties = function(userProperties){
        if(Boolean(APP_CONSTANTS.enableFirebase) == true){
            firebase.analytics().setUserProperties(userProperties);
        }
    }

    
//#endregion